import { render } from "./WorkAreaDetailsListItem.vue?vue&type=template&id=50fbae8a"
import script from "./WorkAreaDetailsListItem.vue?vue&type=script&lang=ts"
export * from "./WorkAreaDetailsListItem.vue?vue&type=script&lang=ts"
script.render = render

export default script